import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductCategory.scss";

const categories = [
  {
    id: 1,
    title: "Fantasy",
    image: "https://i.ibb.co/Nj6MvvV/fantasy-category.jpg",
  },
  {
    id: 2,
    title: "Science Fiction",
    image: "https://i.ibb.co/THNFN22/science-fic-category.jpg",
  },
  {
    id: 3,
    title: "Romance",
    image: "https://i.ibb.co/87m7yJv/romance-category.jpg",
  },
];

const Category = ({ title, image }) => {
  const navigate = useNavigate();

  return (
    <div className="category">
      <h3>{title}</h3>
      <img src={image} alt="cat" />
      <button
        className="--btn --btn-primary --btn-block"
        onClick={() => navigate("/shop")}
      >
        {"View Book"}
      </button>
    </div>
  );
};

const ProductCategory = () => {
  return (
    <div className="categories">
      {categories.map((cat) => {
        return (
          <div className="--flex-center" key={cat.id}>
            <Category title={cat.title} image={cat.image} />
          </div>
        );
      })}
    </div>
  );
};

export default ProductCategory;
